export default {
    isLoggedIn: state => !!Object.keys(state.user).length,
    identity: state => state.user,
    authLanguage: state => Object.keys(state.user).length ? state.user.locale : null,
}
